export const DEFAULT_VALUES = {
  config: undefined,
  id: "animation-player-lottie"
};

export const VALIDATE_KEY_VALUES = {
  config: true,
  id: true
};
